module.exports = __webpack_public_path__ + "media/images/pc/top/recommend_plan_maedori@2x-060d6113c95768890fc67f5418ba99f5.webp";